import React, {Component} from 'react';
import {connect} from "react-redux";
import {LargePrimaryButton, PhoneInput} from '@worthy-npm/clarity';
import {updateMissingDetails} from 'actions/user';

class phoneInput extends Component {
    constructor(props){
        super(props)

        this.state = {
            showValidation: false,
            isValidPhone: true,
            phoneInputValue: ''
        }

        this.updatePhone = this.updatePhone.bind(this);
        this.onPhoneTyped = this.onPhoneTyped.bind(this);
    }

    updatePhone(stopAnimation) {
        let {ADO, finishedUpdate, message} = this.props
        const {phoneInputValue, isValidPhone} = this.state

        if(isValidPhone) {
            updateMissingDetails({
                phone: phoneInputValue,
                user_id: ADO.user.id
            })
            let formattedPhone = `(${phoneInputValue.slice(0,3)})${phoneInputValue.slice(3,6)}-${phoneInputValue.slice(-4)}`
            message.response.text = message.response.text.replace('{user_phone}', formattedPhone)
            finishedUpdate(message)
        }

        this.setState({showValidation: true})
        stopAnimation()
    }

    onPhoneTyped(value, isValid) {
        this.setState({isValidPhone: isValid, phoneInputValue: value.replace(/[\D\s._-]+/g, "")});
    }

    render(){
        return(
            <div className={'phoneContainer'}>
                <div className="inputContainer">
                    <PhoneInput label={'Mobile Number'} showValidationMessage={this.state.showValidation} change={this.onPhoneTyped}/>
                </div>
                <div className="buttonContainer">
                    <LargePrimaryButton text={'Done'} click={(stopAnimation)=>this.updatePhone(stopAnimation)}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ADO}) => {
    return {ADO}
}

export default connect(mapStateToProps)(phoneInput);